import {createRouter, createWebHistory} from 'vue-router'
import LoginView from '@/views/LoginPage.vue'
import DashBoard from "@/views/DashBoard.vue";
import {useAuthStore} from '@/stores/authStore'
import {useWeekStore} from "@/stores/week.js";
import PinPad from "@/components/PinPad.vue";
import HubPage from "@/views/HubPage.vue";
import ProfilePage from "@/views/ProfilePage.vue";
import MorePage from "@/views/MorePage.vue";
import SearchPassenger from "@/views/SearchPassenger.vue";
import Passenger from "@/views/Passenger.vue";
import ActionsPage from "@/views/ActionsPage.vue";
import ResortPage from "@/views/ResortPage.vue";
import HandbookPage from "@/views/HandbookPage.vue";
import LoadCoach from "@/views/LoadCoach.vue";
import PoiPage from "@/views/PoiPage.vue";
import ContactsPage from "@/views/ContactsPage.vue";
import AccommodationPage from "@/views/AccommodationPage.vue";
import AccommodationDetailsPage from "@/views/AccommodationDetailsPage.vue";
import LessonDetails from "@/views/LessonDetails.vue";
import LessonPage from "@/views/LessonPage.vue";
import EventPage from "@/views/EventPage.vue";
import EventDetailsPage from "@/views/EventDetailsPage.vue";
import TicketingPage from "@/views/TicketingPage.vue";
import ScanEvent from "@/views/ScanEvent.vue";
import LiftPass from "@/views/LiftPass.vue";
import SelectCoachToLoad from "@/views/SelectCoachToLoad.vue";
import NightlifePlan from "@/views/NightlifePlan.vue";
import RegisterLesson from "@/views/RegisterLesson.vue";
import ScanLesson from "@/views/ScanLesson.vue";
import WeeklyInformation from "@/views/WeeklyInformation.vue";
import CoachesPage from "@/views/CoachesPage.vue";
import CoachDetails from "@/views/CoachDetails.vue";
import SearchStaff from "@/views/SearchStaff.vue";
import RepPage from "@/views/RepPage.vue";
import SelectTransferToLoad from "@/views/SelectTransferToLoad.vue";
import TransfersPage from "@/views/TransfersPage.vue";
import TransferDetails from "@/views/TransferDetails.vue";
import ShiftPage from "@/views/ShiftPage.vue";
import ClientIssue from "@/views/ClientIssue.vue";
import LoadExtras from "@/views/LoadExtras.vue";
import WorkshopPage from "@/views/WorkshopPage.vue";
import KeyDistribution from "@/views/KeyDistribution.vue";
import SelectKeyDistributionLocation from "@/views/SelectKeyDistributionLocation.vue";
import DistributeKey from "@/views/DistributeKey.vue";
import Notifications from "@/views/Notifications.vue";
import LiftPassLocations from "@/views/LiftPassLocations.vue";
import LoadTransferV2 from "@/views/LoadTransferV2.vue";
import PushRequired from "@/views/PushRequired.vue";
import {usePushReachabilityStore} from "@/stores/pushReachability.js";
import {pushGateRedirect} from "@/services/reachability.js";
import Inbox from "@/views/Inbox.vue";
import {rememberInboxTarget, takeInboxTarget} from "@/services/inbox.js";

const routes = [
    {
        path: "/",
        name: 'SelectWeek',
        component: DashBoard,
        meta: {requiresAuth: true, requiresUnlock: true}
    },
    // New primary routes
    {
        path: "/hub",
        name: 'Hub',
        component: HubPage,
        meta: {requiresAuth: true, requiresUnlock: true, keepAlive: true}
    },
    {
        path: "/scan",
        name: 'Scan',
        component: ActionsPage,
        meta: {requiresAuth: true, requiresUnlock: true, keepAlive: true}
    },
    {
        path: "/profile",
        name: 'Profile',
        component: ProfilePage,
        meta: {requiresAuth: true, requiresUnlock: true, keepAlive: true}
    },
    {
        path: "/more",
        name: 'More',
        component: MorePage,
        meta: {requiresAuth: true, requiresUnlock: true, keepAlive: true}
    },
    // Redirects from old routes
    {
        path: "/home",
        redirect: "/hub"
    },
    {
        path: "/action",
        redirect: "/scan"
    },
    {
        path: "/my-week",
        redirect: "/profile"
    },
    {
        path: "/my-season",
        redirect: "/profile"
    },
    {
        path: "/search-staff",
        name: "SearchStaff",
        component: SearchStaff,
        meta: {requiresAuth: true, requiresUnlock: true, keepAlive: true}
    },
    {
        path: "/rep/:repId",
        name: "Rep",
        component: RepPage,
        meta: {requiresAuth: true, requiresUnlock: true, keepAlive: true}
    },
    {
        path: "/resort",
        name: 'Resort',
        component: ResortPage,
        meta: {requiresAuth: true, requiresUnlock: true, keepAlive: true}
    },
    {
        path: "/ticketing",
        name: 'ticketing',
        component: TicketingPage,
        meta: {requiresAuth: true, requiresUnlock: true, keepAlive: true}
    },
    {
        path: "/ticket/:ticketId",
        name: 'Scan Event',
        component: ScanEvent,
        meta: {requiresAuth: true, requiresUnlock: true, keepAlive: true}
    },
    {
        path: "/liftPass",
        name: 'liftPass',
        component: LiftPassLocations,
        meta: {requiresAuth: true, requiresUnlock: true, keepAlive: true}
    },
    {
        path: "/liftPassDistribution/:locationId",
        name: 'liftPassDistribution',
        component: LiftPass,
        meta: {requiresAuth: true, requiresUnlock: true, keepAlive: true}
    },
    {
        path: "/accommodation",
        name: 'Accommodation',
        component: AccommodationPage,
        meta: {requiresAuth: true, requiresUnlock: true, keepAlive: true}
    },
    {
        path: "/keyDist/room/:roomId/:scanType/:barcode",
        name: 'distKeyBarcode',
        component: DistributeKey,
        meta: {requiresAuth: true, requiresUnlock: true, keepAlive: true}
    },
    {
        path: "/keyDist/room/:roomId/:scanType",
        name: 'distKey',
        component: DistributeKey,
        meta: {requiresAuth: true, requiresUnlock: true, keepAlive: true}
    },
    {
        path: "/keyDist/:groupType/:distLocation",
        name: 'keyDist',
        component: KeyDistribution,
        meta: {requiresAuth: true, requiresUnlock: true, keepAlive: true}
    },
    {
        path: "/keyDist",
        name: 'keyDistSelect',
        component: SelectKeyDistributionLocation,
        meta: {requiresAuth: true, requiresUnlock: true, keepAlive: true}
    },
    {
        path: "/client-issue",
        name: "ClientIssueForm",
        component: ClientIssue,
        meta: {requiresAuth: true, requiresUnlock: true, keepAlive: true}
    },
    {
        path: "/coach",
        name: 'Coaches',
        component: CoachesPage,
        meta: {requiresAuth: true, requiresUnlock: true, keepAlive: true}
    },
    {
        path: "/coach/:coachId",
        name: 'Coach Details',
        component: CoachDetails,
        meta: {requiresAuth: true, requiresUnlock: true, keepAlive: true}
    },
    {
        path: "/transfer",
        name: 'Transfers',
        component: TransfersPage,
        meta: {requiresAuth: true, requiresUnlock: true, keepAlive: true}
    },
    {
        path: "/shift/:shiftId",
        name: 'Shift',
        component: ShiftPage,
        meta: {requiresAuth: true, requiresUnlock: true, keepAlive: true}
    },
    {
        path: "/transfer/:transferId",
        name: 'Transfer Details',
        component: TransferDetails,
        meta: {requiresAuth: true, requiresUnlock: true, keepAlive: true}
    },
    {
        path: "/accommodation/:subblockId",
        name: 'Accommodation Details',
        component: AccommodationDetailsPage,
        meta: {requiresAuth: true, requiresUnlock: true, keepAlive: true}
    },
    {
        path: "/lesson/:lessonId",
        name: 'Lesson Details',
        component: LessonDetails,
        props: {isWorkshop: false},
        meta: {requiresAuth: true, requiresUnlock: true, keepAlive: true}
    },
    {
        path: "/lessons",
        name: 'Lessons',
        component: LessonPage,
        meta: {requiresAuth: true, requiresUnlock: true, keepAlive: true}
    },
    {
        path: "/workshop/:lessonId",
        name: 'Workshop Details',
        component: LessonDetails,
        props: {isWorkshop: true},
        meta: {requiresAuth: true, requiresUnlock: true, keepAlive: true}
    },
    {
        path: "/workshops",
        name: 'Workshops',
        component: WorkshopPage,
        meta: {requiresAuth: true, requiresUnlock: true, keepAlive: true}
    },
    {
        path: "/events",
        name: 'Events',
        component: EventPage,
        meta: {requiresAuth: true, requiresUnlock: true, keepAlive: true}
    },
    {
        path: "/event/:eventId",
        name: 'Event Details',
        component: EventDetailsPage,
        meta: {requiresAuth: true, requiresUnlock: true, keepAlive: true}
    },
    {
        path: "/contacts",
        name: 'Contacts',
        component: ContactsPage,
        meta: {requiresAuth: true, requiresUnlock: true, keepAlive: true}
    },
    {
        path: '/resort/:resortId',
        name: 'ResortPage',
        component: PoiPage,
        meta: {requiresAuth: true, requiresUnlock: true}
    },
    {
        path: "/handbook",
        name: 'Handbook',
        component: HandbookPage,
        meta: {requiresAuth: true, requiresUnlock: true, keepAlive: true}
    },
    {
        path: "/searchPassenger",
        name: 'SearchPassengers',
        component: SearchPassenger,
        meta: {requiresAuth: true, requiresUnlock: true}
    },
    {
        path: "/event-schedule",
        name: 'NightlifePlan',
        component: NightlifePlan,
        meta: {requiresAuth: true, requiresUnlock: true}
    },
    {
        path: "/load-extras",
        name: "LoadExtras",
        component: LoadExtras,
        meta: {requiresAuth: true, requiresUnlock: true}
    },
    {
        path: "/load-extras/:transferId",
        name: "LoadExtrasTransfer",
        component: LoadExtras,
        meta: {requiresAuth: true, requiresUnlock: true}
    },
    {
        path: "/registerLesson",
        name: 'registerLesson',
        component: RegisterLesson,
        props: {isWorkshop: false},
        meta: {requiresAuth: true, requiresUnlock: true, keepAlive: true}
    },
    {
        path: "/registerWorkshop",
        name: 'registerWorkshop',
        component: RegisterLesson,
        props: {isWorkshop: true},
        meta: {requiresAuth: true, requiresUnlock: true, keepAlive: true}
    },
    {
        path: "/registerLesson/:lessonId",
        name: "ScanLesson",
        component: ScanLesson,
        meta: {requiresAuth: true, requiresUnlock: true}
    },
    {
        path: "/week-info/:tab?",
        name: 'WeeklyInfo',
        component: WeeklyInformation,
        meta: {requiresAuth: true, requiresUnlock: true, keepAlive: true}
    },
    {
        path: "/loadCoach/:coachId/:direction",
        name: 'loadCoach',
        component: LoadCoach,
        meta: {requiresAuth: true, requiresUnlock: true}
    },
    {
        path: "/loadCoach",
        name: 'selectLoadCoach',
        component: SelectCoachToLoad,
        meta: {requiresAuth: true, requiresUnlock: true}
    },
    {
        path: "/loadTransferNew/:transferId/:direction",
        name: 'loadTransferV2',
        component: LoadTransferV2,
        meta: {requiresAuth: true, requiresUnlock: true}
    },
    {
        path: "/loadTransfer",
        name: 'selectLoadTransfer',
        component: SelectTransferToLoad,
        meta: {requiresAuth: true, requiresUnlock: true}
    },
    {
        path: "/notifications",
        name: 'Notifications',
        component: Notifications,
        meta: {requiresAuth: true, requiresUnlock: true}
    },
    {
        // Staff inbox (#141, notifications-v2): the list, or one notification. A tapped
        // push opens /inbox/:id?delivery=, which records "opened" on that delivery.
        path: "/inbox/:notificationId?",
        name: 'Inbox',
        component: Inbox,
        meta: {requiresAuth: true, requiresUnlock: true}
    },
    {
        // "Require push" block screen (#149); the guard below sends staff here
        path: "/push-required",
        name: 'PushRequired',
        component: PushRequired,
        meta: {requiresAuth: true, requiresUnlock: true}
    },
    {
        path: '/passenger/:bookingRef',
        name: 'PassengerDetails',
        component: Passenger,
        meta: {requiresAuth: true, requiresUnlock: true}
    },
    {
        path: '/login',
        name: 'Login',
        component: LoginView
    },
    {
        path: '/unlock',
        name: 'Unlock',
        component: PinPad,
        meta: {requiresAuth: true}
    }
]

const PUSH_STATUS_WAIT_MS = 4000

const router = createRouter({
    history: createWebHistory(),
    routes,
    scrollBehavior(to, from, savedPosition) {
        if (savedPosition) {
            // If it's a back/forward navigation, restore the saved position
            return savedPosition
        } else {
            // For new navigations, scroll to top
            return {top: 0}
        }
    }
})

router.beforeEach(async (to, from, next) => {
    const authStore = useAuthStore()
    const weekStore = useWeekStore()

    // Always allow login page
    if (to.name === 'Login') {
        return next()
    }

    // Check login status first
    if (to.meta.requiresAuth && !await authStore.checkLoginStatus()) {
        rememberInboxTarget(to)
        return next('/login')
    }

    // Check if PIN needs to be set up or unlocked
    const isPinSet = await authStore.isPinSet()

    // If no PIN is set and trying to access protected route, redirect to PIN setup
    if (!isPinSet && to.meta.requiresUnlock && to.name !== 'Unlock') {
        rememberInboxTarget(to)
        return next('/unlock')
    }

    // If PIN is set, check lock status
    if (isPinSet && to.meta.requiresUnlock) {
        const isPwaUnlocked = authStore.checkPwaLock()
        if (!isPwaUnlocked && to.name !== 'Unlock') {
            rememberInboxTarget(to)
            return next('/unlock')
        }
    }

    // "Require push" (#149, notifications-v2): blocked staff only reach the push
    // setup screen. The first navigation waits for the status, at most
    // PUSH_STATUS_WAIT_MS; without an answer nothing blocks.
    if (to.meta.requiresAuth) {
        const reach = usePushReachabilityStore()
        await Promise.race([reach.ensureLoaded(), new Promise(resolve => setTimeout(resolve, PUSH_STATUS_WAIT_MS))])
        const redirect = pushGateRedirect({to, blocked: reach.blocked})
        if (redirect) return next(redirect)
    }

    // A tapped push that had to wait for the PIN or login: open it now (#141)
    if (to.meta.requiresUnlock) {
        const inboxTarget = takeInboxTarget(to)
        if (inboxTarget) return next(inboxTarget)
    }

    await weekStore.checkWeekData()
    authStore.resetActivityTimer()
    next()
})

router.afterEach(() => {
    const authStore = useAuthStore()
    authStore.resetActivityTimer()
})

export default router
